import React, { useState, useContext, memo } from 'react';
import { Handle } from 'react-flow-renderer';

import {
  Typography,
  Grid,
  Button,
  Link,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Paper,
  TooltipLight,
  Icon,
  // IconButton,
  MenuItem,
  ListItemIcon,
  ListItemText,
  ButtonDropdownMenu,
} from 'app/design';
import {
  Delete as DeleteIcon,
  Eject as EjectIcon,
  PresentToAll as PresentToAllIcon,
  FileCopy as FileCopyIcon,
  Add as AddIcon,
  Edit as EditIcon,
  MoreHoriz as MoreHorizIcon,
} from 'app/design/icons-material';

import { getAtPath, setAtPath } from 'app/utilities';

import { IvrMenuEventEmitterContext, useSharedFlow } from '../../../../..';

// import { USER_ADDABLE_COMPONENTS } from '../../../../../../Strategies/base/GenericDefault';
// import * as OptionComponents from '../../../../../../Strategies/components';

import { ChooseDialog } from '../../ChooseDialog';
import { IconButton } from '../../../../../../../design-lib';
import {
  Community,
  GitCompare,
  Group,
  LongArrowUpLeft,
  User,
  Phone as PhoneIcon,
} from 'iconoir-react';
import { Tooltip } from '@mui/material';
import IconButtonDropdown from '../../../../../../../design-lib/components/IconButtonDropdown/IconButtonDropdown';
import { USER_ADDABLE_COMPONENTS } from '../../../../../strategies/blank';

export const MenuItem_Replace = props => {
  const { data, mode, onClose, type, current } = props;
  const {
    callflow: rootCallflow,
    insertBefore, // bool
    insertAfterData,
    infoIdx,
    currentCallflow,
    componentData,
    componentInfo,
    templateParent,
    // callflow,
    // setCallflow,
    // modifyPath,
  } = data;
  const ee = useContext(IvrMenuEventEmitterContext);
  const index = insertAfterData.index - 1;
  const { callflow, setCallflow, modifyPath } = insertAfterData;

  const [showInsertBefore, setShowInsertBefore] = useState(null);
  const setShowInsertBeforeWrap = setTo => () => setShowInsertBefore(setTo);

  const handleAdd = opt => {
    // console.log('Replacing', { opt });
    const { type, options, data: newDataOpts } = opt;
    const modules = getAtPath(
      callflow,
      `${modifyPath}.strategy.data.modules`,
      [],
    );

    // console.log('modules:', modules, callflow, modifyPath);
    // index is from the insertAfterData!! (ie, we need to -1 to remove from the correct place)
    const comp = modules.splice(insertAfterData.index - 1, 1);

    setAtPath(callflow, `${modifyPath}.strategy.data.modules`, modules);

    setCallflow({ ...callflow }, { name: `Removed ${comp[0].type}` });

    // TODO: add "recently added" to the data? or use eventemitter?
    // - triggers self to run?
    // - problem if multiple things added??

    // console.log('Add:', type, options, newDataOpts);

    const data = {
      type,
      options,
      data: newDataOpts,
    };

    // const data = {
    //   type: 'MenuGreetingAndTargets',
    // };

    modules.splice(index, 0, data);

    setAtPath(callflow, `${modifyPath}.strategy.data.modules`, modules);

    // console.log('set after insert:', callflow);

    setCallflow({ ...callflow }, { name: `Inserted ${type}` });

    // // TODO: focus after rebuild, instead of on a Timeout
    // window.setTimeout(() => {
    //   ee.emit('focus-node', {
    //     key: `${modifyPath}.strategy.data.modules.${index}`,
    //   });
    // }, 100);

    // TODO: focus after rebuild, instead of on a Timeout
    window.setTimeout(() => {
      // console.log('event emitted');
      ee.emit('node-created', {
        key: `${modifyPath}.strategy.data.modules.${index}`,
        optsPath: `${modifyPath}.strategy.data.modules.${index}`,
      });
    }, 100);
  };

  const options = USER_ADDABLE_COMPONENTS.get(type).filter(c => !c.allowFunc);

  return (
    <>
      {/*{showInsertBefore && (*/}
      {/*  <ChooseDialog*/}
      {/*    {...insertAfterData}*/}
      {/*    requireAllowAfter={true}*/}
      {/*    index={insertAfterData.index - 1}*/}
      {/*    onClose={setShowInsertBeforeWrap(null)}*/}
      {/*  />*/}
      {/*)}*/}
      <Tooltip placement={'right'} title={'Swap module'} arrow>
        <div className={`z-20`}>
          <IconButtonDropdown
            align={'right'}
            pill
            // onClick={e => {
            //   // if (rootCallflow.type != 'template' && templateParent) {
            //   //   alert(
            //   //     'Note that adding to this template outside of a Template Endpoint can result in losing information when the Template is re-applied!',
            //   //   );
            //   // }
            //   // onClose();
            //   setShowInsertBefore(true);
            // }}
            hideArrow
            menuItems={options.map(opt => ({
              label: opt.name,
              icon: opt.icon,
              onClick: () => handleAdd(opt),
              disabled:
                type === 'ring'
                  ? opt.data.ring_type === current
                  : opt.type === current,
            }))}
            size={'sm'}
            variant={'ghost'}
          >
            <GitCompare rotate={90} />
          </IconButtonDropdown>
        </div>
      </Tooltip>

      {/*<MenuItem
        onClick={e => {
          // if (rootCallflow.type != 'template' && templateParent) {
          //   alert(
          //     'Note that adding to this template outside of a Template Endpoint can result in losing information when the Template is re-applied!',
          //   );
          // }
          onClose();
          setShowInsertBefore(true);
        }}
        component={'a'}
      >
        <ListItemIcon>
          <PresentToAllIcon />
        </ListItemIcon>
        <ListItemText primary="Add Before" />
      </MenuItem>*/}
    </>
  );
};

// export const ChooseDialog = (props) => {
//   const {
//     callflow,
//     setCallflow,
//     modifyPath,
//     index,
//     requireAllowBefore, // always false
//     requireAllowAfter,
//     onClose,
//     onAdd, // replaces handleAdd from below!
//   } = props;

//   // modifyPath => to root of callflow!

//   const ee = useContext(IvrMenuEventEmitterContext);

//   // useEffectOnce(() => {
//   //   ee.on('focus-node', focusNode);
//   //   return () => {
//   //     ee.removeListener('focus-node', focusNode);
//   //   };
//   // });

//   // console.log('InsertNode:', data);

//   const handleAdd = (selected) => {
//     // const optKey = selected.value;
//     // const optionComponent = OptionComponents[optKey];

//     // TODO: add "recently added" to the data? or use eventemitter?
//     // - triggers self to run?
//     // - problem if multiple things added??

//     const data = {
//       type: selected.value.type,
//       options: selected.value.options,
//     };

//     // const data = {
//     //   type: 'MenuGreetingAndTargets',
//     // };
//     const components = getAtPath(
//       callflow,
//       `${modifyPath}.strategy.config.components`,
//       []
//     );
//     const stratDataOpts = getAtPath(
//       callflow,
//       `${modifyPath}.strategy.data.opts`,
//       []
//     );
//     // console.log('Adding to index:', index);

//     components.splice(index, 0, data);
//     stratDataOpts.splice(index, 0, {});

//     setAtPath(callflow, `${modifyPath}.strategy.config.components`, components);
//     setAtPath(callflow, `${modifyPath}.strategy.data.opts`, stratDataOpts);

//     // console.log('set after insert:', callflow);

//     setCallflow({ ...callflow }, { name: `Inserted ${selected.value.type}` });

//     // // TODO: focus after rebuild, instead of on a Timeout
//     // window.setTimeout(() => {
//     //   ee.emit('focus-node', {
//     //     key: `${modifyPath}.strategy.config.components[${index}]`,
//     //   });
//     // }, 100);

//     // TODO: focus after rebuild, instead of on a Timeout
//     window.setTimeout(() => {
//       ee.emit('node-created', {
//         key: `${modifyPath}.strategy.config.components[${index}]`,
//         optsPath: `${modifyPath}.strategy.data.opts[${index}]`,
//       });
//     }, 100);
//   };

//   return (
//     <Dialog open onClose={onClose} fullWidth={true} maxWidth="sm">
//       {/* <DialogTitle>Select Option</DialogTitle>
//       <Divider /> */}
//       <DialogContent>
//         <StrategySelect
//           requireAllowBefore={false}
//           requireAllowAfter={requireAllowAfter}
//           onChange={onAdd || handleAdd}
//         />
//       </DialogContent>
//       <Divider />
//       <DialogActions>
//         <Button
//           color="secondary"
//           variant="outlined"
//           onClick={(e) => {
//             onClose();
//           }}
//         >
//           Cancel
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// export const StrategySelect = (props) => {
//   const {
//     placeholder,
//     preventComplexBeforeAfter,
//     requireAllowAfter, // determines if the Selectable module is required to have the "allowAfter" value set
//     requireAllowBefore, // determines if the Selectable module is required to have the "allowBefore" value set
//     onChange,
//     selected,
//   } = props;

//   const [anchorEl, setAnchorEl] = useState(null);
//   const handleClick = (event) => {
//     setAnchorEl(event.currentTarget);
//   };
//   const handleClose = () => {
//     setAnchorEl(null);
//   };

//   // TODO: this list of options should be from a different list of possible "before" and "after" possible components
//   // - type, options[props] like in Strategies.componentConfig.components
//   const options = USER_ADDABLE_COMPONENTS.map((component) => {
//     // console.log('optKey:', optKey);
//     const module = OptionComponents[component.type];
//     // console.log('type:', component.type);
//     const allow = requireAllowBefore
//       ? module.allowBefore === true
//         ? true
//         : false
//       : true && requireAllowAfter
//       ? module.allowAfter === true
//         ? true
//         : false
//       : true;
//     return allow ? { ...component, allow: true } : component;
//   }).map((component) => ({
//     label: component.name,
//     value: component,
//     allow: component.allow,
//     type: component.type,
//   }));

//   const opt = null;
//   return (
//     <>
//       {options
//         .filter((opt) => opt.allow)
//         .map((opt) => (
//           <Paper
//             key={opt.label}
//             lcolor={
//               JSON.stringify(opt) === JSON.stringify(selected)
//                 ? 'teal.50'
//                 : 'grey.50'
//             }
//             onClick={() => onChange(opt)}
//             padding={1}
//             style={{ margin: '4px 0' }}
//             elevation={0}
//             elevateOnHover
//           >
//             <Grid container spacing={1} alignItems="center" noWrap>
//               <Grid item>
//                 <Icon style={{ verticalAlign: 'text-top' }} fontSize="small">
//                   {opt.value.icon ?? 'help_outline'}
//                 </Icon>
//               </Grid>
//               <Grid item>
//                 <Typography variant="body2" strong>
//                   {opt.label}
//                 </Typography>
//               </Grid>
//             </Grid>
//           </Paper>
//         ))}
//     </>
//   );
// };

export default MenuItem_Replace;
